module.exports = __webpack_public_path__ + "img/bl-hero-2.315e2e5f.jpg";